import React from 'react'
import { ARTICLE_FEATURED_TYPES } from '../../../constants'
import ArticleOverlay from '../../utils/ArticleOverlay'
import ImageWrapper from './styled/ImageWrapper'
import CoveredImage from './CoveredImage'
import Image from './SimpleImage'
import { type OverlayImageProps } from '../Types'

export default (props: OverlayImageProps) => {
  const {
    covered,
    duration,
    imageClass,
    imageComponent: ImageComponent = Image,
    imageWrapperComponent: ImageWrapperComponent = ImageWrapper,
    overlaySize,
    overlayType,
    src
  } = props

  const featuredTypes = [].concat(ARTICLE_FEATURED_TYPES.COMMON).concat(ARTICLE_FEATURED_TYPES.IMAGE)

  return (
    <ImageWrapperComponent>
      {
        featuredTypes.includes(overlayType) &&
        <ArticleOverlay className={`${overlaySize || ''} ${overlayType}`}>
          {
            overlayType === 'video' && duration
          }
        </ArticleOverlay>
      }
      {
        covered ? <CoveredImage src={src}/> : <ImageComponent className={imageClass} src={src}/>
      }
    </ImageWrapperComponent>
  )
}
